import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'product',
    children: [
      {
        path: ':productId',
        children: [
          {
            path: 'setting',
            title: 'Thumb Zone | Product Setting',
            loadComponent: () =>
              import('./product-setting/product-setting.component').then(
                (c) => c.ProductSettingComponent,
              ),
          },
          {
            path: 'start',
            title: 'Thumb Zone | Start',
            loadComponent: () =>
              import('./product-start/product-start.component').then(
                (c) => c.ProductStartComponent,
              ),
          },
          {
            path: 'edit',
            title: 'Thumb Zone | Product Edit',
            loadComponent: () =>
              import('./product-edit/product-edit.component').then((c) => c.ProductEditComponent),
          },
          {
            path: 'flows',
            title: 'Thumb Zone | Flows',
            loadChildren: () => import('./product-flow/product-flow.routes').then((r) => r.routes),
          },
          {
            path: 'studies',
            title: 'Thumb Zone | Studies',
            loadChildren: () =>
              import('./product-study/product-study.routes').then((r) => r.routes),
          },
          {
            path: 'screens',
            title: 'Thumb Zone | Screens',
            loadChildren: () =>
              import('./product-screen/product-screen.routes').then((r) => r.routes),
          },
          {
            path: 'personas',
            title: 'Thumb Zone | Personas',
            loadChildren: () =>
              import('./product-persona/product-persona.routes').then((r) => r.routes),
          },
          {
            path: 'segments',
            title: 'Thumb Zone | Segments',
            loadChildren: () =>
              import('./product-segment/product-segment.routes').then((r) => r.routes),
          },
          {
            path: 'sessions',
            title: 'Thumb Zone | Sessions',
            loadComponent: () =>
              import('./product-session/product-session.component').then(
                (c) => c.ProductSessionComponent,
              ),
          },
        ],
      },
    ],
  },
];
